import React, { Suspense, lazy } from "react";
import WebWork from "../components/WebWork";
import "./styles/home.css";
const FrontBanner = lazy(() => import("../components/FrontBanner"));
const Works = lazy(() => import("../components/Works"));
const Card = lazy(() => import("../components/Card"));
const CV = lazy(() => import("../components/CV"));
const Headline = lazy(() => import("../components/Headline"));
const Raster = lazy(() => import("../components/Raster"));
const WhyUs = lazy(() => import("../components/WhyUs"));
const Flyer = lazy(() => import("../components/Flyer"));
const VideoEdit = lazy(() => import("../components/VideoEdit"));
const LetsMake = lazy(() => import("../components/LetsMake"));
const HowItWorks = lazy(() => import("../components/HowItWorks"));
const WhatWeDo = lazy(() => import("../components/WhatWeDo"));

export default function Home() {
  return (
    <div>
      <Suspense fallback={""}>
        <FrontBanner />
        <WhatWeDo />
        <Works />
        <CV />
        <WebWork />
        <Flyer />
        <Card />
        <Raster />
        <VideoEdit />
        <HowItWorks />
        <WhyUs />
        <LetsMake />
      </Suspense>
    </div>
  );
}
